import { Injectable, inject } from '@angular/core';
import {
	ActivatedRouteSnapshot,
	Route,
	RouterStateSnapshot,
	UrlSegment,
} from '@angular/router';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { AuthState } from 'src/shared/state/auth.state';

@Injectable({
	providedIn: 'root',
})
export class CanViewFullUserGuard {
	private store = inject(Store);

	canViewFullUser: Observable<boolean> = this.store.select(
		AuthState.canViewFullUser
	);

	canActivate(
		_route: ActivatedRouteSnapshot,
		_state: RouterStateSnapshot
	): Observable<boolean> {
		return this.canViewFullUser;
	}

	canLoad(_route: Route, _segments: UrlSegment[]): boolean {
		return this.store.selectSnapshot(AuthState.canViewFullUser);
	}
}
